export default {
  header: 'Štítky udalostí',
  empty: 'Zatiaľ neboli vytvorené žiadne štítky udalostí.',
  confirmDeleteMessage: 'Udalosti, ktoré majú tento štítok, si ho ponechajú.',
};
